module.exports = __webpack_public_path__ + "static/media/cross-mark.af8567fd.svg";